// extracted by mini-css-extract-plugin
export default {"mainWrapper":"commodity-information_mainWrapper__M2DnC","boxWrapper":"commodity-information_boxWrapper__-yxtW","rowWrapper":"commodity-information_rowWrapper__F3ebH"};